export default function authHeader() {
    return {'Access-Control-Allow-Origin': '*'};
}

